var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-layout-topbar"},[_c('h1',{on:{"click":function($event){return _vm.showVersion()}}},[_vm._v(_vm._s(_vm.nomeEmpresa))]),_c('div',{class:['home-layout-topbar-menubutton', { rotate: _vm.mostraMenu }],on:{"click":function($event){return _vm.alternaMenu()}}},[_c('img',{attrs:{"src":require("@/assets/icones/menu.png")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }